import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../tooltip';
import { Icon, Info } from '@components/atoms/icons';
import { Button } from '../../../../molecules/button/button';

interface IInfoTooltipProps {
	content: React.ReactNode;
	delayDuration?: number;
}

const DEFAULT_DELAY_DURATION = 300;

const InfoTooltip: React.FC<IInfoTooltipProps> = ({ content, delayDuration = DEFAULT_DELAY_DURATION }) => {
	return (
		<TooltipProvider>
			<Tooltip delayDuration={delayDuration}>
				<TooltipTrigger asChild>
					<Button iconButton variant="icon" size="sm">
						<Icon color="tertiary">
							<Info />
						</Icon>
					</Button>
				</TooltipTrigger>
				<TooltipContent className="max-w-sm">{content}</TooltipContent>
			</Tooltip>
		</TooltipProvider>
	);
};

export { InfoTooltip };
export type { IInfoTooltipProps };
